<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
  >
    <g clip-path="url(#clip0_3515_159003)">
      <path
        d="M34.3636 6.54545H26.1818V1.63636C26.1818 1.20237 26.0094 0.786157 25.7025 0.47928C25.3957 0.172402 24.9794 0 24.5455 0H11.4545C11.0206 0 10.6043 0.172402 10.2975 0.47928C9.99058 0.786157 9.81818 1.20237 9.81818 1.63636V6.54545H1.63636C1.20237 6.54545 0.786157 6.71786 0.47928 7.02473C0.172402 7.33161 0 7.74783 0 8.18182C0 8.61581 0.172402 9.03202 0.47928 9.3389C0.786157 9.64578 1.20237 9.81818 1.63636 9.81818H3.46418L6.55855 34.5665C6.60799 34.9622 6.80023 35.3263 7.09914 35.5902C7.39804 35.8542 7.78305 35.9999 8.18182 36H27.8182C28.217 35.9999 28.602 35.8542 28.9009 35.5902C29.1998 35.3263 29.392 34.9622 29.4415 34.5665L32.5358 9.81818H34.3636C34.7976 9.81818 35.2138 9.64578 35.5207 9.3389C35.8276 9.03202 36 8.61581 36 8.18182C36 7.74783 35.8276 7.33161 35.5207 7.02473C35.2138 6.71786 34.7976 6.54545 34.3636 6.54545ZM13.0909 3.27273H22.9091V6.54545H13.0909V3.27273ZM26.3733 32.7273H9.62673L6.76309 9.81818H29.2369L26.3733 32.7273Z"
        fill="#3F3F3F"
      />
    </g>
    <defs>
      <clipPath id="clip0_3515_159003">
        <rect
          width="36"
          height="36"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
